import { createContext, useContext } from 'react';

export interface ClerkClientAuth {
  isClerkSignedIn: boolean;
  isClerkLoading: boolean;
  clerkUser: unknown;
  clerkEmail: string | null;
  clerkUserId: string | null;
  clerkSignOut: (options?: { redirectUrl?: string }) => Promise<void>;
  getClerkToken: () => Promise<string | null>;
}

const noopSignOut = async () => {};
const noopGetToken = async () => null;

export const defaultClerkAuth: ClerkClientAuth = {
  isClerkSignedIn: false,
  isClerkLoading: false,
  clerkUser: null,
  clerkEmail: null,
  clerkUserId: null,
  clerkSignOut: noopSignOut,
  getClerkToken: noopGetToken,
};

export const ClerkAuthContext = createContext<ClerkClientAuth>(defaultClerkAuth);

export function useClerkClientAuth(): ClerkClientAuth {
  return useContext(ClerkAuthContext);
}